// format returned 1st Jan 2021, 10:10

type FormattedTime = {
  date: string;
  time: string;
  formatted: string;
};

type SuffixProps = {
  [key: string]: string;
};

const daySuffixObj: SuffixProps = {
  '1': 'st',
  '2': 'nd',
  '3': 'rd',
  others: 'th',
};

type Props = {
  time: string;
  showFullYear?: boolean;
  showShortMonth?: boolean;
  showDaySuffix?: boolean;
  showHoursMins?: boolean;
  showSeconds?: boolean;
  showComma?: boolean;
};

const getDateFormat = ({
  time,
  showFullYear = false,
  showShortMonth = true,
  showDaySuffix = true,
  showSeconds = false,
  showComma = true,
}: Props): FormattedTime => {
  const date = new Date(time);

  const fullYear = date.getFullYear().toString();

  const year = showFullYear ? fullYear : fullYear.substr(-2);
  const monthFormat = showShortMonth ? 'short' : 'long';
  const month = date.toLocaleString(undefined, { month: monthFormat });
  const day = date.getDate();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  const suffix = daySuffixObj[day.toString()] || daySuffixObj['others'];

  const daySuffix = showDaySuffix ? suffix : '';

  const separator = showComma ? ',' : '';

  const dateResult = `${day}${daySuffix} ${month}${separator} ${year}`;
  const timeResult = `${hours}:${minutes}${showSeconds ? `:${seconds}` : ''}`;

  return {
    date: dateResult,
    time: timeResult,
    formatted: `${dateResult} ${timeResult}`,
  };
};

export default getDateFormat;
